import { Ref, RefCallback } from "react";

/**
 * Merge multiple refs together.
 * @function mergeRefs
 * @param {ForwardedRef<T>[]} refs
 * @returns {RefCallback<T>}
 */
export const mergeRefs = <T>(
	...refs: (Ref<T> | undefined)[]
): RefCallback<T> => {
	/**
	 * Ref callback that merges multiple refs together.
	 * @param node
	 */
	const ref = (node: T) => {
		for (const ref of refs) {
			if (!ref) continue;

			if (typeof ref === "function") ref(node);

			if ("current" in ref) ref.current = node;
		}
	};

	return ref;
};
